import { InjectionToken } from '@angular/core';
import { FavoriteBooksServiceInterface } from './favorite-books.service.interface';

export const FAVORITE_BOOKS_SERVICE_TOKEN = new InjectionToken<FavoriteBooksServiceInterface>('FavoriteBooksService');
